import AuthLayout from '../AuthLayout';
import ForgotPassword from '../Forms/ForgotPassword';

const ForgotPasswordPage = () => {
  return (
    <AuthLayout title="Forgot Password" subtitle="">
      <ForgotPassword />
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
